import cx from "classnames"
import { AlertCircle, Wrench } from "lucide-react"
import type { GroupRenderer, OrchestrationGroup } from "../../events/messageGroups"
import { orchestrationGroupLabel } from "../../events/presentation"

function OrchestrationContent({ group }: { group: OrchestrationGroup }) {
    return (
        <div>
            {group.calls.length > 0 && (
                <div className="px-3 py-2">
                    <div className="text-xs text-muted font-medium mb-1">Calls</div>
                    <div className="flex flex-col gap-1">
                        {group.calls.map((call, index) => (
                            <div key={`${call.toolName}-${index}`} className="flex min-w-0 gap-2 text-xs">
                                <span className="font-mono text-muted flex-shrink-0">{call.toolName}</span>
                                {call.detail && <span className="font-mono text-base-content truncate">{call.detail}</span>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {group.source && (
                <div className={cx("px-3 py-2", group.calls.length > 0 && "border-t border-border")}>
                    <div className="text-xs text-muted font-medium mb-1">Orchestration source</div>
                    <pre className="text-xs overflow-x-auto max-h-48 overflow-y-auto p-2 bg-base-200 border border-border whitespace-pre-wrap">
                        {group.source}
                    </pre>
                </div>
            )}
            {group.result !== undefined && (
                <div className="px-3 py-2 border-t border-border">
                    <div className={cx("text-xs font-medium mb-1", group.isError ? "text-error" : "text-muted")}>{group.isError ? "Error" : "Result"}</div>
                    <pre
                        className={cx(
                            "text-xs overflow-x-auto max-h-48 overflow-y-auto p-2 border whitespace-pre-wrap",
                            group.isError ? "bg-error/10 border-error/20" : "bg-base-200 border-border"
                        )}
                    >
                        {group.result}
                    </pre>
                </div>
            )}
        </div>
    )
}

export const orchestrationRenderer: GroupRenderer<OrchestrationGroup> = {
    getLabel: orchestrationGroupLabel,
    getIcon: () => <Wrench size="0.85em" className="text-muted flex-shrink-0" />,
    getStatusIcon: (group) => {
        if (group.isError) return <AlertCircle size="1em" className="text-error flex-shrink-0" />
        return null
    },
    getHeaderInfo: () => null,
    renderContent: (group) => <OrchestrationContent group={group} />,
}
